import React, { useContext } from "react";
import { PageWrapper } from "../../components";
import { AuthContext } from "../../../context";
import DisableOffer from "./disable-offer";
import PromoSBC from "./remise/caracteristique-promo";
import RemiseSBC from "./remise/critere-application";
import "./config.scss";
import InvoiceHelp from "./invoice/invoice-help";
import UploadCguComponent from "./upload-cgu";

const Config = () => {
    const { user } = useContext(AuthContext);
    return (
        <PageWrapper className="faq-wrapper" fullPage>
            <UploadCguComponent />
            <div className="offers-config">{user && user.superUser && <InvoiceHelp />}</div>
            <div className="offers-config">{user && user.superUser && <DisableOffer />}</div>
            <div className="offers-config">{user && user.superUser && <PromoSBC />}</div>
            <div className="offers-config">{user && user.superUser && <RemiseSBC />}</div>
        </PageWrapper>
    );
};
export default Config;
